import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AwardVotingApi, { AwardVotingPeriod } from "../../Api/AwardVotingApi";

const PendingAwardsList: React.FC = () => {
  const [periods, setPeriods] = useState<AwardVotingPeriod[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let active = true;
    AwardVotingApi.getPending()
      .then((res) => {
        if (active) setPeriods(res.data ?? []);
      })
      .catch(() => {
        if (active) setPeriods([]);
      })
      .finally(() => {
        if (active) setLoaded(true);
      });
    return () => {
      active = false;
    };
  }, []);

  if (!loaded || periods.length === 0) return null;

  return (
    <div className="p-4 border rounded shadow bg-white">
      <h2 className="text-lg font-semibold mb-2">Awards Voting</h2>
      <p className="text-sm text-gray-600 mb-2">
        Voting is open and you have not voted yet.
      </p>
      <ul className="space-y-2">
        {periods.map((period) => (
          <li key={period.id}>
            <Link
              to={`/members/awards/vote/${period.id}`}
              className="text-blue-600 hover:underline"
            >
              {period.title}
              {period.subscriptionName ? ` (${period.subscriptionName})` : ""}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PendingAwardsList;
